import React from "react";
import Paginations from "react-js-pagination";

export default function Pagination(props) {
  return ( 
      <div className="row mt-10">
        <div className="d-flex align-items-center justify-content-between">
        <div 
        style={{fontSize:'15px',fontWeight:'600'}}
          id="example2_info"
          role="status"
          aria-live="polite"
          className="px-2"
        >
         Showing {props.totaldata ? props.counting + 1 : 0} to{" "}
          {props.counting + 10 < props.totaldata
            ? props.counting + 10
            : props.totaldata
            ? props.totaldata
            : 0}{" "}
          of {props.totaldata ? props.totaldata : 0} entries
        </div>

        <div className="p-1">
          <Paginations
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="⟨"
            nextPageText="⟩"
            firstPageText="«"
            lastPageText="»"
            // prevPageText="Prev"
            // nextPageText="Next"
            // firstPageText="First"
            // lastPageText="Last"
            // hideFirstLastPages={true}
            activePage={props.activePage + 1}
            totalItemsCount={props.totaldata}
            onChange={props.onChangePage}
          />
        </div>
        </div>
      </div> 
  );
}
